'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _buyTicketHtml = require('./buy-ticket.html');

var _buyTicketHtml2 = _interopRequireDefault(_buyTicketHtml);

var _buyTicketController = require('./buy-ticket.controller');

var _buyTicketController2 = _interopRequireDefault(_buyTicketController);

function routeConfig($stateProvider) {
	'ngInject';

	$stateProvider.state('app.public.btms.buy-ticket', {
		url: '/buy-ticket?ticketId&ticketPrice',
		template: _buyTicketHtml2['default'],
		controller: _buyTicketController2['default'],
		controllerAs: 'vm',
		// 'params': {
		// 	'ticketPrice': ''
		// },
		'resolve': {
			'Ticket': function Ticket(TicketComponent, $stateParams) {
				'ngInject';

				return TicketComponent.showTicket($stateParams.ticketId);
			},
			'EpayButton': function EpayButton(PaymentComponent, $stateParams, $location) {
				'ngInject';

				var urls = {
					'url_cancel': $location.protocol() + '://' + $location.host(),
					'url_ok': $location.protocol() + '://' + $location.host() + '/payment-ready'
				};

				return PaymentComponent.fetchPaymentButton($stateParams.ticketId, urls);
			}
		}
	});
}

exports['default'] = routeConfig;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/public/main/buy-ticket/buy-ticket.route.js
 **/